"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighChartsMeasuredRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_measure_1 = tslib_1.__importDefault(require("react-measure"));
var MEASURED_ELEMENT_STYLE = { width: "100%", height: "100%" };
function HighChartsMeasuredRenderer(props) {
    return (react_1.default.createElement(react_measure_1.default, { client: true }, function (_a) {
        var measureRef = _a.measureRef, contentRect = _a.contentRect;
        return (react_1.default.createElement("div", { className: "visualization-container-measure-wrap", style: MEASURED_ELEMENT_STYLE, ref: measureRef }, props.childrenRenderer(contentRect)));
    }));
}
exports.HighChartsMeasuredRenderer = HighChartsMeasuredRenderer;
//# sourceMappingURL=HighChartsMeasuredRenderer.js.map